import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import MagnifyingGlassMigrateSvg from '../../../assets/icons/app/MagnifyingGlassMigrate.svg?raw';

export const MagnifyingGlassMigrateIcon = (props) => (
    <CustomSVG svg={MagnifyingGlassMigrateSvg} preserveColors appIconSmall {...props} />
);
